import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import { joinValuesToString } from 'ziphy-web-shared/basic/helpers';
import { getObservationSubType } from '../extractor.helpers';
import { prepareMeta, prepareValueDateTime } from '../fhir.converters';
import { getCodingObjects, getExtensionObjects, getIdentifierObjects, getObservationValues, } from '../fhir.helpers';
import { joinArrayWithObjectToString } from '../fhir.utils';
import ExtractorBase from './Base';
class ExtractorObservation {
    constructor(resource) {
        this.base = new ExtractorBase(this);
        this.base.SET(resource);
        makeAutoObservable(this);
    }
    get resource() {
        return this.base.resource;
    }
    get subType() {
        return getObservationSubType(this);
    }
    /*
     * RESOURCE - Minimally prepared resource data, prepareConverters, valueObjects, etc.
     */
    get extensions() {
        return getExtensionObjects(this.resource.extension);
    }
    get identifiers() {
        return getIdentifierObjects(this.resource.identifier);
    }
    get categories() {
        return getCodingObjects(this.resource.category);
    }
    get codes() {
        return getCodingObjects(this.resource.code);
    }
    // other in the FHIR - Group | Device
    get subject() {
        return this.base.getChildExtractor(this.resource.subject);
    }
    // other in the FHIR - CareTeam
    get performers() {
        return _.map(this.resource.performer, (x) => this.base.getChildExtractor(x));
    }
    get effectiveDateTime() {
        return prepareValueDateTime(this.resource.effectiveDateTime);
    }
    get meta() {
        return prepareMeta(this.resource.meta);
    }
    /*
     * READ - PREPARED Values
     */
    get zid() {
        return this.identifiers.first({ config: 'zid' });
    }
    get codeObj() {
        return this.codes.first();
    }
    get performer() {
        return _.last(this.performers);
    }
    get values() {
        return getObservationValues(this.resource);
    }
    get socialHistoryValueComment() {
        return this.extensions.first('observationSocialHistoryValueComment');
    }
    get notes() {
        return this.resource.note;
    }
    /*
     * STRING Values
     */
    get asString() {
        var _a, _b, _c, _d;
        const tmp = {
            codeDisplay: (_a = this.codeObj) === null || _a === void 0 ? void 0 : _a.display,
            values: joinArrayWithObjectToString(this.values, 'asString', ', '),
            notes: joinArrayWithObjectToString(this.notes, 'text', '; '),
            socialHistoryValueComment: ((_c = prepareValueDateTime((_b = this.socialHistoryValueComment) === null || _b === void 0 ? void 0 : _b.value)) === null || _c === void 0 ? void 0 : _c.asString) ||
                ((_d = this.socialHistoryValueComment) === null || _d === void 0 ? void 0 : _d.asString),
            full: '',
        };
        tmp.full = joinValuesToString([tmp.codeDisplay, tmp.values, tmp.socialHistoryValueComment, tmp.notes], ' • ');
        return tmp;
    }
}
export default ExtractorObservation;
